var map = {
	"./alisa.png": 866,
	"./alisa@2x.png": 776,
	"./ameron.png": 867,
	"./ameron@2x.png": 777,
	"./avida.png": 868,
	"./avida@2x.png": 778,
	"./bigbank.png": 869,
	"./bigbank@2x.png": 779,
	"./blank.png": 870,
	"./blank@2x.png": 780,
	"./bondora.png": 871,
	"./bondora@2x.png": 781,
	"./brocc.png": 872,
	"./brocc@2x.png": 782,
	"./businesscredit.png": 873,
	"./businesscredit@2x.png": 783,
	"./capitalbox.png": 874,
	"./capitalbox@2x.png": 784,
	"./capitalboxflex.png": 875,
	"./capitalboxflex@2x.png": 785,
	"./cashbuddy.png": 876,
	"./cashbuddy@2x.png": 786,
	"./collectorbank.png": 877,
	"./collectorbank@2x.png": 787,
	"./credento.png": 878,
	"./credento@2x.png": 788,
	"./credigo.png": 879,
	"./credigo@2x.png": 789,
	"./credinord.png": 880,
	"./credinord@2x.png": 790,
	"./euroloan.png": 881,
	"./euroloan@2x.png": 791,
	"./fellowfinance.png": 882,
	"./fellowfinance@2x.png": 792,
	"./fellowfinancebusiness.png": 883,
	"./fellowfinancebusiness@2x.png": 793,
	"./ferratum.png": 884,
	"./ferratum@2x.png": 794,
	"./ferratumbusinessflex.png": 885,
	"./ferratumbusinessflex@2x.png": 795,
	"./fundu.png": 886,
	"./fundu@2x.png": 796,
	"./halino.png": 887,
	"./halino@2x.png": 797,
	"./instabank.png": 888,
	"./instabank@2x.png": 798,
	"./kasvurahoitus.png": 889,
	"./kasvurahoitus@2x.png": 799,
	"./koincapital.png": 890,
	"./koincapital@2x.png": 800,
	"./komplettbank.png": 891,
	"./komplettbank@2x.png": 801,
	"./laina.fi.png": 892,
	"./laina.fi@2x.png": 802,
	"./lainaaja.png": 893,
	"./lainaaja@2x.png": 803,
	"./lainaamo.png": 894,
	"./lainaamo@2x.png": 804,
	"./leabank.png": 895,
	"./leabank@2x.png": 805,
	"./luottorahoitus.png": 896,
	"./luottorahoitus@2x.png": 806,
	"./mastercard.png": 897,
	"./mastercard@2x.png": 807,
	"./mylender.png": 898,
	"./mylender@2x.png": 808,
	"./nordaxbank.png": 899,
	"./nordaxbank@2x.png": 809,
	"./norwegian.png": 900,
	"./norwegian@2x.png": 810,
	"./ostosraha.png": 901,
	"./ostosraha@2x.png": 811,
	"./qred.png": 902,
	"./qred@2x.png": 812,
	"./resursbank.png": 903,
	"./resursbank@2x.png": 813,
	"./saldo.png": 904,
	"./saldo@2x.png": 814,
	"./santander.png": 905,
	"./santander@2x.png": 815,
	"./surimo.png": 906,
	"./surimo@2x.png": 816,
	"./svea.png": 907,
	"./svea@2x.png": 817,
	"./sveabusiness.png": 908,
	"./sveabusiness@2x.png": 818,
	"./tando.png": 909,
	"./tando@2x.png": 819,
	"./tuohi.png": 910,
	"./tuohi@2x.png": 820,
	"./vauraus.png": 911,
	"./vauraus@2x.png": 821,
	"./vauraus_transparent.png": 912,
	"./yritysluotto.png": 913,
	"./yritysluotto@2x.png": 822,
	"./yritysluottoflex.png": 914,
	"./yritysluottoflex@2x.png": 823
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 768;